import React, { Fragment, useState, useEffect } from 'react'
import SingleSelect from "../../common/Forms/SingleSelect";

const SchoolSelect = () => {
  const [schools, setSchools] = useState([])
  const [selectedSchool, setSelectedSchool] = useState(null)

  useEffect(() => {
    const fetchSchools = async () => {
      let response = await fetch('/api/v1/orders/schools_for_export')
      response = await response.json()
      setSchools(response.data)
    }

    fetchSchools();
  }, [])

  return (
    <Fragment>
      <input name="export[school_id]"
             value={selectedSchool && selectedSchool.value}
             hidden />
      <SingleSelect
        handleChange={(data) => setSelectedSchool(data) }
        options={schools}
        selectedValue={selectedSchool}
        showCheckbox={true}
        placeholderText='Select School (do not select to download all)'
      />
    </Fragment>
  )
}

export default SchoolSelect
